export default __webpack_public_path__ + "static/media/03.90e176f2.png";